import useSite from "./useSite";
import authService from "@/services/AuthService";
import { resolveTimeZone } from "@/utils/formatInSiteTz";

/** Product default when nothing else resolves — TIMES ALWAYS PACIFIC. */
export const DEFAULT_DISPLAY_TZ = "America/Los_Angeles";

/**
 * Returns the timezone to use for rendering dates/times.
 * Precedence: user profile override → site setting → America/Los_Angeles (PT).
 *
 * NEVER browser-local. Browser-local made every timestamp render in the viewer's own zone
 * (UTC on servers/CI/other regions), showing times hours off even though the stored data and
 * the site setting ("Pacific Standard Time") are correct. Per the standing rule, the platform
 * default is Pacific — a customer only sees a different zone if they explicitly set one.
 *
 * The value is always run through resolveTimeZone(), so it is guaranteed to be a valid IANA
 * zone — never a Windows TZ name or other string that would make Date.toLocaleString throw.
 */
export default function useResolvedTimezone(): string {
  const { site } = useSite();
  const userTz = (authService.profile as { timeZone?: string })?.timeZone;
  return resolveTimeZone(userTz || site?.timezone) || DEFAULT_DISPLAY_TZ;
}
